import React, { createContext, useContext, useEffect, useState } from "react";
import { db } from "../Services/firebase-config";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";
import Loading from "../Components/loading/Loading";

const EventsContext = createContext();

export const useEvents = () => {
    const context = useContext(EventsContext);
    if (!context) {
        throw new Error("useEvents must be used within an EventsProvider");
    }
    return context;
};

export const EventsProvider = ({ children }) => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        try {
            const eventsRef = collection(db, "events");
            const q = query(eventsRef, orderBy("startDate", "desc"));

            const unsubscribe = onSnapshot(q, (snapshot) => {
                const eventsData = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setEvents(eventsData);
                setLoading(false);
            });

            return () => unsubscribe();
        } catch (err) {
            console.error("Error setting up events listener:", err);
            setError(err.message);
            setLoading(false);
        }
    }, []);

    const value = {
        events,
        loading,
        error,
        getEventById: (eventId) => events.find((e) => e.id === eventId),
    };

    return (
        <>
            {loading && <Loading />}
            <EventsContext.Provider value={value}>{children}</EventsContext.Provider>
        </>
    );
};
